import { Capacitor } from '@capacitor/core';
import type { BillingAdapter } from './BillingAdapter';
import { BillingWeb } from './BillingWeb';
import { BillingNative } from './BillingNative';

export function getBillingAdapter(): BillingAdapter {
  const platform = Capacitor.getPlatform();

  if (platform === 'android' || platform === 'ios') {
    return new BillingNative();
  }

  return new BillingWeb();
}